module.exports = __webpack_public_path__ + "static/media/03.533de881.gif";